const server = process.env.REACT_APP_SERVER;
const serverG2 = process.env.REACT_APP_G2;
const serverOpen = process.env.REACT_APP_OPEN_API;


export { server, serverG2, serverOpen};
